/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/services"/>
import {get, post} from "Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest";
import { IEmailSettings, IRejectionAction, IRejectManagementReasonCode, ISupplierInvoiceRejectionDto } from "./interfaces";

export function getActiveRejectManagementReasonCodes(hierarchyId: string):Promise<Array<IRejectManagementReasonCode>> {
    return get(`remedium-api/apa/rejectManagement/activeReasonCodes?hierarchyId=${encodeURIComponent(hierarchyId)}`);
}

export async function postISupplierInvoiceRejectionDto(reasonCode: ISupplierInvoiceRejectionDto):Promise<number>{
    return post("remedium-api/apa/rejectManagement/reject", reasonCode);
}

export async function getEmailSettings(): Promise<IEmailSettings> {
    return get(`remedium-api/apa/rejectManagement/emailSettings`);
}

export async function getActiveRejectionActions(hierarchyId: string): Promise<IRejectionAction[]> {
    return get(`remedium-api/apa/rejectionAction/activeActions?hierarchyId=${encodeURIComponent(hierarchyId)}`);
}

export async function getReasonRequiredUponRejection(companyId: number): Promise<boolean> {
    return get(`remedium-api/apa/rejectManagement/isReasonRequiredUponRejection?companyId=${companyId}`);
}

export async function getSelectedReasonCodes(documentId: number): Promise<Array<IRejectManagementReasonCode>> {
    return get(`remedium-api/apa/rejectManagement/invoices/${documentId}/rejection-reasons`);
}